import React, { useEffect, useState } from 'react';
import * as gmailServices from '../../../services/gmail';
import { Button } from 'components/ui';
import { getEnv } from '../../../services/env-service';
import { useGetAuthorizedDomains } from '../../../query/admin';
import { Select } from 'antd';
import { getUserToken } from 'services/token';

const AuthorizeGmailAccountButton = ({ setLoading, setError }) => {
  const [domain, setDomain] = useState('turing.com');
  const { data: authorizedDomain, isLoading } = useGetAuthorizedDomains();

  useEffect(() => {
    if (window && getEnv('NODE_ENV') === 'production') {
      setDomain(
        window.location.hostname
          .split('.')
          .slice(-2)
          .join('.'),
      );
    }
  }, []);

  async function handleInitiateAuthorize() {
    setLoading(true);
    const response = await gmailServices
      .authorizeGmailAccount(domain)
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });

    if (response?.authUrl) {
      window.location.href = response.authUrl;
    } else {
      setError('Something went wrong');
    }
    setLoading(false);
  }

  const onChangeDomain = (selectedDomain: string) => {
    setDomain(selectedDomain);

    if (domain === selectedDomain) return;
    if (getEnv('NODE_ENV') !== 'production') return;

    const urlObj = new URL(window.location.href);
    urlObj.hostname = [
      ...urlObj.hostname.split('.').slice(0, -2),
      selectedDomain,
    ].join('.');
    const searchParams = new URLSearchParams(urlObj.search);
    searchParams.set('auth', getUserToken());
    urlObj.search = searchParams.toString();
    window.location.href = urlObj.toString();
  };

  return (
    <div className="flex items-center space-x-2">
      {getEnv('ENV') !== 'production' && (
        <Select loading={isLoading} value={domain} onChange={onChangeDomain}>
          {authorizedDomain.map(d => (
            <Select.Option key={d.id} value={d.name}>
              {d.name}
            </Select.Option>
          ))}
        </Select>
      )}
      <Button onClick={handleInitiateAuthorize}>
        <span className="material-icons">touch_app</span>
        Authorize *@{domain}
      </Button>
    </div>
  );
};

export default AuthorizeGmailAccountButton;
